import React from 'react';

import { groupItemsBy } from '../../services/utils';

const CONTRACT_TYPES = ['OTC', 'CME', 'Physical'];

class MarketlogFilter extends React.Component {

    constructor(props) {
        super(props);

        this.getCheckboxList = this.getCheckboxList.bind(this);
        this.getValue = this.getValue.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeAll = this.onChangeAll.bind(this);
        this.onChangeMultiple = this.onChangeMultiple.bind(this);
        this.areAllChecked = this.areAllChecked.bind(this);
        this.getChooseAll = this.getChooseAll.bind(this);
    }

    closePopup(e) {
        if (e.target.getAttribute('name') == 'marketlogFilter')
            this.props.hidePopup();
    }

    getCheckboxList() {
        let list = [];
        const type = this.props.params.type;

        switch(type) {
            case 'products':                
                const marketGroups = groupItemsBy(this.props.params.data, 'marketname');
                for (let market in marketGroups) {
                    const contractGroups = groupItemsBy(marketGroups[market], 'contract_type');
           
                    CONTRACT_TYPES.forEach(contract => {                        
                        if (!contractGroups[contract]) {
                            return;
                        }

                        list.push({
                            id: null,
                            name:`${market.toUpperCase()} - ${contract.toUpperCase()}`,
                            children: contractGroups[contract].map(item => {
                                return { id: item.id, name: item.short_name };
                            })
                        });
                    });
                }
                break;
            case 'intents':
                list = [{
                    name: 'BID',
                    id: 'BUY'
                }, {
                    name: 'OFFER',
                    id: 'SELL'
                }];
                break;
            case 'status':
                list = ['OPEN', 'EXPIRED'];
                break;
            case 'contract_type':
                list = CONTRACT_TYPES;
                break;
        }

        if (!list || !list.length) {
            return null;
        }

        if (type == 'intents') {
            return list.map((item, i) =>
                <li key={'filter' + item.id}>                    
                    <input type='checkbox' name={'prod'+item.id}
                        onChange={()=>this.onChange(type, item.id)}
                        checked={this.getValue(type, item.id)} />
                    <div className='checkbox-title'>{item.name}</div>
                </li>
            );
        } else if (type == 'products') {
            return list.map((item, i) => 
                <li key={'group' + item.name}>                    
                    <input type='checkbox' onChange={(e) => this.onChangeMultiple(e, type, item.children.map(child => child.id))}
                        checked={this.getValueMultiple(type, item.children.map(child => child.id))} />
                    <div className='checkbox-title'>{item.name}</div>
                    <ul>
                        {item.children.map(child => 
                            <li key={'filter' + child.id} className='filter-child'>                    
                                <input type='checkbox' name={'prod'+child.id}
                                    onChange={()=>this.onChange(type, child.id)}
                                    checked={this.getValue(type, child.id)} />
                                <div className='checkbox-title'>{child.name}</div>
                            </li>
                        )}
                    </ul>
                </li>
            );
        } else {
            return list.map((item, i) =>
                <li key={'filter'+i}>
                    <input type='checkbox' name={'prod'+item}
                        onChange={()=>this.onChange(type, item)}
                        checked={this.getValue(type, item)} />
                    <div className='checkbox-title'>{item}</div>
                </li>
            );
        }
    }

    getValue(type, item) {
        let { include } = this.props.args;

        if (include[type])
            return ( include[type].indexOf(item) != -1 ) ? 'checked' : '';
    }

    getValueMultiple(type, items) {
        let { include } = this.props.args;

        if (!include[type]) {
            return '';
        }
        
        return items.find(item => include[type].indexOf(item) < 0) ? '' : 'checked';
    }

    onChange(type, item) {
        const { include } = this.props.args;

        if (include[type]) {
            let itemIndex = include[type].indexOf(item),
            items = [].concat(include[type]);

            if (itemIndex != -1) {
                items.splice(itemIndex, 1);
            } else {
                items.push(item);
            }
            
            this.setNewIncludedItems(type, items);
        }
    }

    onChangeMultiple(event, type, items) {
        const { include } = this.props.args;

        if (!include[type]) {
            return;
        }
        
        const newItems = [].concat(include[type]);        
        if (event.target.checked) {
            items.forEach(item => {
                if (newItems.indexOf(item) < 0) {
                    newItems.push(item);
                }
            });
        } else {
            items.forEach(item => {
                if (newItems.indexOf(item) >= 0) {
                    newItems.splice(newItems.indexOf(item), 1);
                }
            });
        }

        this.setNewIncludedItems(type, newItems);     
    }

    setNewIncludedItems(type, items) {
        let { args, refreshMarketlog } = this.props;

        let newArgs = {
            ...args,
            include: {
                ...args.include,
                [type]: items
            }
        }
        refreshMarketlog(newArgs);   
    }

    getTypeTitle(type) {
        let string = type;
        if (type=='intents') string = 'intent';
        if (type=='intents-custom') string = 'order type';
        if (type=='contract_type') string = 'contract type';

        return 'Please select '+string;
    }

    areAllChecked(type) {
        const { include } = this.props.args;
        const checkedCount = include[type] && include[type].length || 0
        
        if (type === 'products') {
            return this.props.params.data.length === checkedCount ? 'checked' : ''; 
        }
        else if (type === 'contract_type') {
            return CONTRACT_TYPES.length === checkedCount ? 'checked' : '';
        }
    }

    onChangeAll(event, type) {        
        const { include } = this.props.args;
        
        if (include[type]) {
            let items = [];
            
            if (event.target.checked) {
                if (type === 'products') {
                    items = this.props.params.data.map(product => product.id);
                }
                else if (type === 'contract_type') {
                    items = CONTRACT_TYPES;
                }
            }

            this.setNewIncludedItems(type, items);
        }
    }

    getChooseAll(type) {
        if (type === 'products' || type === 'contract_type') {
            return (
                 <li>
                    <input type='checkbox' name={'prodall'}
                        onChange={(event) => this.onChangeAll(event, type)}
                        checked={this.areAllChecked(type)} />
                    <div className='checkbox-title'>Choose all</div>
                </li>
            );
        }
    }

	render() {
        const { visible, params, args } = this.props;
        const { data, type } = params;
        
        return (
            <div name='marketlogFilter'
                onClick={this.closePopup.bind(this)}
                className='worklog-popup-container generic-popup-container'
                style={{ display: visible ? 'block' : 'none'}}>

                <div className='worklog-dropdown'>
                    <center><h2 className='title'>{this.getTypeTitle(type)}</h2></center>
                    <ul>
                        {this.getChooseAll(type)}
                        {this.getCheckboxList()}                        
                    </ul>
                </div>
            </div>
        )
    }
}

export default MarketlogFilter;



// WEBPACK FOOTER //
// ./source/screens/markets/marketlogFilter.js